<kendo-dialog id="make-payment-modal" *ngIf="(vm$ | async) as vm" width="400">
<ng-container *ngIf="!vm.hasError">
        <i class="fa-2x fas fa-spinner fa-spin" style="margin-right:5px; float:left"></i>
        <span id="processing-msg" role="alert" style="display:contents">Processing the payment.  Please do not close this window.</span>
</ng-container>
<ng-container *ngIf="vm.hasError">
    <i class="fas fa-exclamation-triangle error-text" style="margin-right:5px"></i>
    <!--<button class="close-button" aria-hidden="true" (click)="closeModal()">X</button>-->
    <b id="error-title" role="alert" class="error-text">{{vm.errorTitle}}</b>
    <p id="error-msg-1" role="alert" class="error-text" style="margin-top:10px">{{vm.errorMsg1}}</p>
    <p *ngIf="vm.errorMsg2" id="error-msg-2" role="alert" class="error-text" style="margin-top:10px">{{vm.errorMsg2}}</p>
    <div *ngIf="vm.errorDetails">
        <div id="error-details" class="error-text error-details" [innerHTML]="vm.errorDetails"></div>
        <br />
    </div>
    
    <button id="button-close" class="btn btn-primary submit-button" (click)="closeModal()">Close</button>
</ng-container>
</kendo-dialog>
    

